import $ from 'jquery';
import _ from 'lodash';
import { EDITOR_MODE_DEFAULT } from '~config/editorConstants';
import {
  toggleEditorHomeMenu,
  calculateFormat,
  resizeDimensions,
  getCanvasBaseZoom,
  composeMetadataCanvasNavText,
} from '~loader/loader-utils';
import { fetchCanvas } from '~src/api';
import { loadEditor } from '~core';
import { onCanvasNotFound } from '~src/errors';

export const openCanvasById = async (canvasId) => {
  window.editorLoader.canvasId = canvasId;

  $('.app-spinner').show();
  const editorMode = window.urlParams.get('mode') || EDITOR_MODE_DEFAULT;

  toggleEditorHomeMenu();

  try {
    const canvas = await fetchCanvas(canvasId);
    composeMetadataCanvasNavText();
    const { formatWidth, formatHeight } = calculateFormat();

    const isDefaultFormat = _.has(
      canvas,
      'editor_project_formats_default_pointer.objectId'
    );

    const dpi = isDefaultFormat
      ? _.get(canvas, 'editor_project_formats_default_pointer.dpi')
      : _.get(
          canvas,
          'editor_project_formats_pointer.dpi',
          window.editorLoader.sourceDPI
        );

    const { width, height } = resizeDimensions(
      formatWidth,
      formatHeight,
      window.editorLoader.defaultDPI,
      dpi
    );

    const zoomValue = getCanvasBaseZoom(width, height);

    await loadEditor({
      width,
      height,
      zoom: zoomValue,
      editorMode,
    });
  } catch (error) {
    console.error(error);
    $('.app-spinner').hide();
    onCanvasNotFound();
  }
};
